export default {
    methods: {
        fixBodyScroll () {
            setTimeout( () => {
                document.body.style.overflow='auto';
            },  600);
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/general.js